import React from "react";
import clsx from "clsx";
import {
	useTranslationControls,
	useTranslator,
} from "@brickme/frontend-common/src/i18n/translation.tsx";
import Modal from "~/components/modal.tsx";

type LanguageModalProps = {
	readonly show: boolean;
	readonly onClose: () => void;
};

function LanguageModal({ show, onClose }: LanguageModalProps) {
	const t = useTranslator();
	const { languageOptions, currentLanguage, setCurrentLanguage } =
		useTranslationControls();

	return (
		<Modal show={show} title={t("Select language")} onClose={onClose}>
			<div className="default-modal__text  default-modal__text__align-center">
				<div className="editor-sidebar__paint-tools-btns btns-group js-btns-group">
					{languageOptions.map((language) => (
						<button
							key={language.code}
							type="button"
							onClick={() => setCurrentLanguage(language)}
							className={clsx(
								"btns-group__item",
								"js-btns-group__item",
								"button",
								"button_type_ghost",
								"button_color_ghost-yellow",
								{ active: language === currentLanguage },
							)}
						>
							<div className="btns-group__item-text" style={{ height: 26 }}>
								{language.name}
							</div>
						</button>
					))}
				</div>
			</div>
			<Modal.Actions
				actions={[
					{
						text: t("Close"),
						onClick: onClose,
					},
				]}
			/>
		</Modal>
	);
}

export default LanguageModal;
